import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";

const MobileLogin = () => {
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [error, setError] = useState("");
    const errRef = useRef();

    useEffect(() => {
        const login = async () => {
            try {
                const token = searchParams.get("token");
                const response = await axios.post("/mobile/auth", {
                    token,
                });
                localStorage.setItem("token", response.data.token);
                setAuth({
                    token: response.data.token,
                    user: response.data.user,
                });
                
                localStorage.setItem('from-mobile', true)
                navigate("/my-membership");
            } catch (err) {
                console.error(err);

                setError(
                    err?.response?.data?.message ??
                    "Unable to authenticate."
                );
            }
        };

        login();
    }, []);

    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50">
            <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-lg text-center">

                {error ? (
                    <>
                        <h1 className="text-xl font-semibold text-red-600">
                            Login Failed
                        </h1>

                        <p
                            ref={errRef}
                            className="mt-4 text-slate-600"
                        >
                            {error}
                        </p>
                    </>
                ) : (
                    <>
                        <FontAwesomeIcon
                            icon={faSpinner}
                            spin
                            className="mb-6 text-4xl text-hub-primary"
                        />

                        <h1 className="text-2xl font-semibold text-[#41264B]">
                            Signing you in...
                        </h1>

                        <p className="mt-3 text-slate-500">
                            Please wait while we securely sign you into your account.
                        </p>
                    </>
                )}

            </div>
        </div>
    );
};

export default MobileLogin;